<template>
  <div class="flex w-full pt-8 pb-2 min-h-77px">
    <div class="w-1/3">
      <div class="w-full mb-2.5 h-3px bg-4y-sky-blue" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-7 h-7 -mt-1 -ml-1 text-4y-sky-blue'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M12 4a8 8 0 100 16 8 8 0 000-16m-.569 11.892l-4.036-3.248 1.254-1.558 2.445 1.967 4.002-5.191 1.584 1.221z"/></svg>
          </div>
          <div
            v-if="activeStep <= 1"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none rounded-full"
            :class="[ activeStep === 1 ? 'bg-4y-sonny-yellow text-4y-nightsky-blue' : 'bg-4y-sky-blue text-white' ]"
          >
            1
          </div>
        </div>
        <span class="px-1 " :class="{ 'text-4y-nightsky-blue font-bold pt-1': activeStep === 1, 'text-4y-sky-blue': activeStep > 1 }">{{ step1 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 2 ? 'bg-4y-sky-blue': 'bg-4y-gray-200']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 2">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-7 h-7 -mt-1 text-4y-sky-blue'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M12 4a8 8 0 100 16 8 8 0 000-16m-.569 11.892l-4.036-3.248 1.254-1.558 2.445 1.967 4.002-5.191 1.584 1.221z"/></svg>
          </div>
          <div
            v-if="activeStep <= 2"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none rounded-full"
            :class="[ activeStep === 2 ? 'bg-4y-sonny-yellow text-4y-nightsky-blue' : 'text-4y-gray-400' ]"
          >
            2
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-4y-nightsky-blue': activeStep === 2, 'text-4y-sky-blue': activeStep > 2, 'text-4y-gray-400': activeStep < 2 }">{{ step2 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 3 ? 'bg-4y-sky-blue': 'bg-4y-gray-200']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div
            v-if="activeStep <= 3"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none rounded-full"
            :class="[ activeStep === 3 ? 'bg-4y-sonny-yellow text-4y-nightsky-blue' : 'text-4y-gray-400' ]"
          >
            3
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-4y-nightsky-blue': activeStep === 3, 'text-4y-gray-400': activeStep > 3, 'text-4y-gray-400': activeStep < 3 }">{{ step3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherNavigation from '~components/navigation/step-navigation'

export default VoucherNavigation.extend()
</script>
